import { CarrierServiceType } from '../carrier/carrier.model';

export enum DraftReturnItemAction {
  Refund = 'REFUND',
  ExchangeToCredits = 'STORE_CREDIT',
  ExchangeToItem = 'EXCHANGE',
}

export enum ReturnReasonAction {
  Refund = 'Refund',
  Exchange = 'Exchange',
  Other = 'Other',
}

export enum PaymentMethod {
  PayPal = 'paypal',
  Adyen = 'adyen',
}

export type DraftReturnItemToExchange = {
  itemId: string;
  skuCode: string;
  skuDesc: string;
  imgPath: string;
  color?: {
    label: string;
    hex: string;
  };
  size?: string;
};

export type DraftReturnItemReason = {
  action: DraftReturnItemAction;
  reason: string;
  reasonCategory: string;
  wish: string;
  comment: string;
  code: string;
  itemToExchange: DraftReturnItemToExchange | null;
  storeCreditsToExchange: {
    value: number;
    unit: string;
  } | null;
};

export type DraftReturnItem = {
  _id: string;
  skuCode: string;
  skuDesc: string;
  imgPath: string;
  quantity: number;
  price: number | undefined;
  cycleonId: string;
  action: DraftReturnItemAction;
  reasons: DraftReturnItemReason[];
  clientMetadata: Record<string, string>;
};

export type CreateDraftReturnWithoutSOInput = {
  currentStepSlug: string;
  step: number;
};

export type DraftReturn = {
  _id: string;
  orderReference: string;
  orderId: string;
  step: number;
  currentStepSlug: string;
  currencyCode: string;
  name: string;
  email: string;
  phoneNumber: string;
  country: string;
  county: string;
  postCode: string;
  city: string;
  state: string;
  address1: string;
  address2: string;
  companyName: string;
  carrierServiceId: number;
  cycleonReturnOrderId: string;
  carrierServiceName: string;
  carrierServiceType: CarrierServiceType;
  carrierServiceImgPath: string;
  isCarrierServiceFree: boolean;
  postalCompanyId: number;
  cycleonRmaNumber: string;
  deliveryPrice: number;
  deliveryCurrency: string;
  deliveryWasPaid: boolean;
  paymentMethod: PaymentMethod;
  paymentDetails: Record<string, any>;
  voucher: string;
  collectionDate: Date;
  collectionInterval: number;
  dropOffPointId: string;
  dropOffPointAddress: string;
  items: DraftReturnItem[];
  returnWasCreated: boolean;
  downloadReturnsFormUrl: string;
  label: string;
  labelType: string;
  tracking: string;
  feedbackRate: number;
  feedbackNote: string;
  language: string;
};
